import { useState, useRef, useEffect } from "react";
import NavBar from "../Components/NavBar";

function NavToggle(props) {
  const [navToggle, setNavToggle] = useState(false);
  const node = useRef();

  const handleClick = (e) => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setNavToggle(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  const navClick = () => {
    setNavToggle(!navToggle);
  };

  return (
    <div>
      <div className={`sidebar ${navToggle ? "nav-toggle" : ""}`}>
        <NavBar />
      </div>
      <div ref={node} className="nav-btn" onClick={navClick}>
        <div className="lines-1"></div>
        <div className="lines-2"></div>
        <div className="lines-3"></div>
      </div>
    </div>
  );
}

export default NavToggle;
